import _ from 'lodash';
import {
  DesignInput,
  DesignInputSpeakAs,
  DesignModule,
  VariableScope,
  VariableType
} from '../../../types';
import { filterNull } from '../array';
import { getVariablesFromText, GetVariablesFromTextProps } from './get-variables-from-text';

export type GetInputsFromTextProps = (
  GetVariablesFromTextProps
  & {
    /** Module the @see node is from. */
    nodeModule: DesignModule;
  }
);

export function getInputsFromText(props: GetInputsFromTextProps): DesignInput[] {
  const variables = _.uniqBy(
    getVariablesFromText(props),
    ({ fullName }) => {
      return fullName;
    }
  );
  const {
    node,
    nodeModule,
    serialized
  } = props;
  const nodeInputs = node?.props.config.inputs ?? [];

  return filterNull(variables.map(({
    fullName,
    scope,
    variableName
  }): DesignInput | null => {
    const nodeInput = nodeInputs.find((input) => {
      return input.varName === fullName;
    });

    if (nodeInput) {
      return nodeInput;
    }

    const variables = (scope === VariableScope.application) ? (
      serialized.components.variables
    ) : (
      nodeModule.localVariables
    );
    const variable = variables?.find((variable) => {
      return variable.props.config.varName === variableName;
    })?.props.config;

    return (!variable) ? null : {
      argumentName: fullName,
      defaultValue: variable.defaultValue ?? '',
      sensitiveData: variable.sensitiveData,
      speakAs: DesignInputSpeakAs.word,
      type: VariableType.variable,
      value: null,
      varName: fullName
    };
  }));
}
